var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sh-heading',{attrs:{"type":_vm.tag,"size-mobile":_vm.mobileSize,"size-desktop":_vm.desktopSize}},[_c('sc-text',{class:{hint : _vm.isEditMode},attrs:{"field":_vm.textField,"tag":"span","data-heading":_vm.tag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }